import { Avatar, Button, ButtonGroup, Container, Divider, Grid, Icon, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import { Image } from '@material-ui/icons';
import React, { useState } from 'react'
import TimetableItem from './TimetableItem';
import firebase from 'firebase';
import ImageIcon from '@material-ui/icons/Image';


function Timetable(props) {

    const {raspored} = props
    
    const [day,setDay] = useState(Object.keys(raspored)[0]);
   
    
    const handleDayChange = (el) => {
        
        setDay(el)
    }

   

    
  
    
function NES(props){
    const {obj,day} = props

    const date = new Date(day)
    const showDate = date.getDate()+"."+(date.getMonth() + 1)+"."+date.getFullYear()
    const [openModal,setOpenModal] = useState(false)

    function handleCloseModal(e){
        setOpenModal(false)
      }

      function handleOpenModal(e){
        setOpenModal(true)
      }
    

    return <React.Fragment>
            <h1 style={{textAlign:"center"}}>{showDate}</h1>
    {Object.keys(obj).map(el=>{
        let row = obj[el];
       
        return <React.Fragment>

        <Grid container
        
        alignContent="center"
        direction="row"
        textAlign="center"
        justifyContent="center"
        style={{padding:"20px",width:"100%",margin:"0 auto",borderBottom:"2px solid #1F94C2",paddingBottom:"20px",
        fontFamily: "Raleway sans-serif",maxWidth:"1200px"
    }}
        
        >
            
           
                <Grid item lg={8} md={12} sm={12} onClick={handleOpenModal}>
                <Typography style={{fontSize:"20px"}}>
                {row.time}
                </Typography>
                <Typography variant="h5" style={{textAlign:"left",}}> 
                {row.name}  
                </Typography>
                <Typography variant="h6" style={{textAlign:"left"}}>
                {row.ime} {row.prezime}
                </Typography>
                <Typography>KLIKNITE OVDJE ZA VIŠE INFORMACIJA</Typography>
                
                {/* <Typography style={{textAlign:"left",}}>
                {row.opis}
                </Typography> */}
                </Grid>

                <Grid item lg={4} md={12} sm={12}>
                <Container alignContent="right" alignItems="right"> 
                <Typography style={{textAlign:"left"}}>
                <span textAlign="left" style={{color:"#1F94C2"}}>LOKACIJA:</span> 
                {row.lokacija}
                </Typography>
                <Typography  style={{textAlign:"left",alignContent:"left"
                }}>
                <span textAlign="center" style={{color:"#1F94C2",textAlign:"right"}}>MAKSIMALAN BROJ GOSTIJU:</span>
                {row.max_guests}
                </Typography>
                <Typography style={{textAlign:"left"}}>
                <span textAlign="left" style={{color:"#1F94C2"}}>TRAJANJE IZLAGANJA:</span>
                {row.length}min
                </Typography >
                
                </Container>
                </Grid>
           
            </Grid>


            <>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{margin:"50px auto",width:"80%",overflow:"scroll"}}
             
              >
                  <Container style={{backgroundColor:"white",border:"2px solid lightblue",padding:"10px",}}>
                      <Typography variant="h3" style={{borderBottom:"2px solid #1F94C2"}}> {row.name} | {row.ime} {row.prezime}</Typography>
                      <Typography>
                          {row.opis}
                      </Typography>
                        <Button variant="contained" style={{backgroundColor:"#1F94C2",color:"white",marginTop:"10px"}} onClick={handleCloseModal}>ZATVORI</Button>
                  </Container>
                </Modal>
                </>


        </React.Fragment>

    })}
  
    </React.Fragment>
}
      

    const useStyles = makeStyles((theme) => ({
        root: {
          '& > *': {
            margin: theme.spacing(2),
            width:"100%"

          },
        },
      }));
      const classes = useStyles()

    return (
        <Container maxWidth={false} style={{width:"100%",backgroundColor:"#F6F7FD",padding:"0",margin:"0 auto"} }>
        <Grid
        id="raspored"
        container 
        direction="column"  
        justify="space-around"   
        alignContent="center" 
        alignItems="center" 
        style={{paddingBottom:"50px",marginTop:"50px",marginBottom:"50px", width: "100%"}}
       >

            <Grid item style={{
                width: "100%"
            }}>
                <Grid container direction="column"  alignItems="center">
                    <Typography variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold"}}>
                        RASPORED
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                        Događaji po Danima
                    </Typography>
                </Grid>
            </Grid>    
   
            
            {/* TODO RED DASH  AND FIX THE BUTTONS ON SMALLER*/}
            <Grid item style={{
                width: "100%"
            }}>
                <Grid container direction="row"  justify="center"   className={classes.root}>
                    <ButtonGroup className={classes.root} size="medium" style={{maxWidth:"800px"}}>
                    {console.log(raspored)}
                    
                    {
                        Object.keys(raspored)
                        .filter(el=>raspored[el]!="arr")
                        .map((el,indx)=>{
                          
                            return <Button onClick={()=>{handleDayChange(el)}} variant="contained" style={{color:"white",backgroundColor: el==day? " #9A4E43" : "#1F94C2"}}>{1+indx+". dan"}</Button>
                        })

                    } 
                        
                    </ButtonGroup>
                   
                   
                </Grid>
                <React.Fragment>
                   
                 
                        <NES obj = {raspored[day]} day={day}/>

                        </React.Fragment>
            </Grid>







        </Grid>
        </Container>
    )
}



//TODO FIX PADDINGS
const buttonStyle = {
    padding:"10px 100px",
    borderRadius:"50px",
};

const listStyle ={
    width: '67%',

}

export default Timetable
